import {
    httpEditPlannedAccesses,
    HttpEditPlannedAccessesOptions
} from '@/features/planned-accesses/http/plannedAccesses.http'
import {ProjectPlannedAccess} from '@/features/planned-accesses/types'
import {MUTATION_KEYS, QUERY_KEYS, queryClient} from '@/queryClient'
import {ErrorResponseData} from '@/types'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

export const useEditPlannedAccesses = (
    projectId: string,
    id: string,
    options?: UseMutationOptions<
        ProjectPlannedAccess,
        AxiosError<ErrorResponseData>,
        HttpEditPlannedAccessesOptions['payload']
    >
) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.EDIT_PLANNED_ACCESSES, projectId, id],
        mutationFn: payload => httpEditPlannedAccesses({urlParams: {projectId, id}, payload}),
        onSuccess: (response, variables, context) => {
            void queryClient.cancelQueries({queryKey: [QUERY_KEYS.PROJECTS]})
            void queryClient.cancelQueries({queryKey: [QUERY_KEYS.PROJECT, projectId]})
            void queryClient.cancelQueries({queryKey: [QUERY_KEYS.PLANNED_ACCESSES, projectId]})
            void queryClient.cancelQueries({queryKey: [QUERY_KEYS.PLANNED_ACCESSES_DETAILS, projectId]})
            void queryClient.cancelQueries({queryKey: [QUERY_KEYS.PROJECT_VALIDATORS, projectId]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECTS]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECT, projectId]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PLANNED_ACCESSES, projectId]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PLANNED_ACCESSES_DETAILS, projectId]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECT_VALIDATORS, projectId]})

            options?.onSuccess?.(response, variables, context)
        }
    })
}
